define('models/MacaronModel',['underscore','ObjectModel','LocalStorage'],function (_,ObjectModel,LocalStorage) {
    //
    // Model Macaron
    //
    var MacaronModelPrototype = {
        
        name:'MacaronModel',
        idAttribute:'id_macaron',
        route:'apiMacaronModel',
        
        initialize:function(){
            // ObjectModel constructor heritage
            ObjectModel.prototype.initialize.apply(this,arguments);
            //
            if(!this.get(this.idAttribute)){
                this.attributes[this.idAttribute] = this.get('id');
            }
        },
        getName:function(){return this.get('name')}
    };

    var MacaronModel = ObjectModel.extend(LocalStorage).extend(MacaronModelPrototype);
    
    return MacaronModel;
});
